import { render, staticRenderFns } from "./CompanyAutocomplete.vue?vue&type=template&id=33054832&scoped=true"
import script from "./CompanyAutocomplete.vue?vue&type=script&lang=ts"
export * from "./CompanyAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33054832",
  null
  
)

export default component.exports